import { MessageType, readyMessage, initResponseMessage, memeCreatedMessage, } from "./index.js";
/** IFrame finished loading, parent must sent initialization message. */
function ready(iframe, styleVariables) {
    var _a;
    const initMessage = {
        messageType: MessageType.INIT,
        payload: styleVariables,
    };
    (_a = iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(initMessage, "*");
}
/** IFrame initialization complete, parent must handle errors if any, or await finished meme. */
function initResponse(message, reject) {
    if (message.payload.status === "ok") {
    }
    else {
        const { err = [] } = message.payload;
        console.error("Initialization errors:", err);
        reject(new Error(`Initialization failed: ${err.join(", ")}`));
    }
}
/** User finished creating meme, parent must clean up iframe and make use of meme. */
function memeCreated(message, resolve) {
    const memeUrl = message.payload;
    resolve(memeUrl);
}
/** Returns a handler function for the client, which handles messages from the iframe/server. */
export function create(iframe, styleVariables, resolve, reject) {
    return (event) => {
        switch (event.data.messageType) {
            case MessageType.READY:
                readyMessage.parse(event.data);
                ready(iframe, styleVariables);
                break;
            case MessageType.INIT_RESPONSE:
                initResponse(initResponseMessage.parse(event.data), reject);
                break;
            case MessageType.MEME_CREATED:
                memeCreated(memeCreatedMessage.parse(event.data), resolve);
                break;
            default:
                console.warn(`Unhandled message type.`, event);
        }
    };
}
//# sourceMappingURL=handlers.js.map